module.exports = __webpack_public_path__ + "img/tradein-full-1.06b97b1f.jpg";